import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './libs/ui/middlewares/AuthGuard/auth-guard.service';
import { AppUrlComponent } from './public/appurl/app-url.component';
import { NotFoundComponent } from './shared-layout/Components/not-found/not-found.component';
import { DocumentDownloadComponent } from './document-download/document-download.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    redirectTo: '/home/login',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./login/login.module').then((mod) => mod.LoginModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((mod) => mod.DashboardModule),
  },
  {
    path: 'site-management',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./site-management/site-management.module').then(
        (mod) => mod.SiteManagementModule
      ),
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./user-management/user-management.module').then(
        (mod) => mod.UserManagementModule
      ),
  },
  {
    path: 'home/privacy-policy',
    loadChildren: () =>
      import('./privacy-policy/privacy-policy.module').then(
        (mod) => mod.PrivacyPolicyModule
      ),
  },
  {
    path: 'home/term-of-use',
    loadChildren: () =>
      import('./terms-of-use/term-of-use.module').then(
        (mod) => mod.TermOfUseModule
      ),
  },
  {
    path: "app",
    component: AppUrlComponent,
  },
  {
    path: 'assets/guide/documents/:fileName',
    component: DocumentDownloadComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
